import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";

import { DELETE_BLOB_STORAGE_INTEGRATION } from "./gql";

const useBlobStorageIntegrationDelete = createDefaultMutationHook(DELETE_BLOB_STORAGE_INTEGRATION);

const useDeleteBlobStorageIntegration = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const [blobStorageIntegrationDelete, { loading }] = useBlobStorageIntegrationDelete({
    refetchQueries: ["SearchVCSIntegrations"],
  });

  const deleteBlobStorageIntegration = useCallback(
    (id: string, attachedEntitiesQty: number, successCallback?: () => void) => {
      return blobStorageIntegrationDelete({ id }, (data) => {
        if (data) {
          reportSuccess({
            message: `${
              data?.blobStorageIntegrationDelete?.name || "Blob Storage"
            }  integration successfully deleted`,
          });
          successCallback?.();

          trackSegmentAnalyticsEvent("Integration - Unlink Confirm", {
            attachedEntitiesQty,
            integration: "Blob Storage",
          });
        }
      });
    },
    [blobStorageIntegrationDelete, reportSuccess, trackSegmentAnalyticsEvent]
  );

  return { deleteBlobStorageIntegration, loading };
};

export default useDeleteBlobStorageIntegration;
